<template>
    <span v-if="navPermissions['reports'].enable">
        <a
            :aria-expanded="reportCollaps"
            class="sidebar-menu-item nav-link"
            data-toggle="collapse"
            @click="(reportCollaps=!reportCollaps)">
            <template>
                <i class="fa pr-2 fa-file-invoice text-danger"></i>
                <span class="nav-link-text">Reports<b class="caret"></b></span>
            </template>
        </a>
        <collapse-transition :duration="{enter: 500, leave: 500}">
            <div v-show="reportCollaps" id="collapse-just" :class="reportCollaps?'show':''" class="collapse">
                <ul class="nav nav-sm flex-column">
                    <slot name="title">
                        <router-link
                            :target="link.target"
                            class="nav-link"
                            href="/reports"
                            to="/reports"
                            @click.native="linkClick"
                        >
                            <template>
                                <i class="fa fa-industry text-primary pr-2"></i>
                                <span class="nav-link-text">Dashboard</span>
                            </template>
                        </router-link>
                    </slot>
                </ul>
            </div>
        </collapse-transition>
    </span>
</template>
<script>
import {CollapseTransition} from "vue2-transitions";
import initService from "@/common/api-services/init-service";

export default {
  name: 'side-reports-group',
  components: {
    CollapseTransition
  },
  data() {
    return {

      isPortalAdminStatus: false,
      isAdminStatus: false,
      groups: [],

      reportCollaps: false,
      link: {
        name: '',
        icon: '',
        path: '',
        children: []
      },

      navPermissions: {
        "reports": {
          enable: false,
          role: ["REPORTS_READ", "Administrator"]
        }
      }
    }
  },
  mounted() {
    this.isPortalAdminStatus = initService.getPortalAdminRole();
    this.isAdminStatus = initService.getAdministratorRole() || initService.getPortalAdminRole();
    this.groups = initService.getGroups();
    Object.keys(this.navPermissions).map(item => {
      this.groups.map(it => {
        if (this.navPermissions[item].role.includes(it)) this.navPermissions[item].enable = true;
      });
    });
  },
  methods: {
    linkClick() {
      if (
          this.autoClose &&
          this.$sidebar &&
          this.$sidebar.showSidebar === true
      ) {
        this.$sidebar.displaySidebar(false);
      }
    },
  }
}
</script>